import { useLogout } from 'hooks/api/useUser';
import { useTranslation } from 'react-i18next';
import { SimpleErrorModal } from './SimpleErrorModal';

export const NoStaffModal = () => {
  const { t } = useTranslation();
  const { mutate: logout } = useLogout();

  return (
    <SimpleErrorModal
      title={t('no_staff_title')}
      description={t('no_staff_description')}
      buttonText={t('return_to_login_button')}
      buttonAction={() => logout({})}
    />
  );
};
